document.addEventListener("turbo:load", function () {
  const formWrapper = document.getElementById("bill-form-data");
  if (!formWrapper) return;

  let billType = formWrapper.dataset.billType;
  let contractItemsData = JSON.parse(formWrapper.dataset.contractItems);
  let maxWeight = parseFloat(formWrapper.dataset.maxWeight);
  let sellerBillWeights = JSON.parse(formWrapper.dataset.sellerBillWeights);
  let quantityUnit = formWrapper.dataset.quantityUnit;

  let financerField = document.querySelector(".financer-field");

  if (billType === "seller") {
    financerField.style.display = "none";
  } else {
    financerField.style.display = "block";
  }

  const sellerSelect = document.querySelector("[name='bill[seller_id]']");
  const financerSelect = document.querySelector("[name='bill[financer_id]']");
  const weightInput = document.querySelector("[name='bill[weight]']");
  const amountInput = document.querySelector("[name='bill[amount]']");
  const remainingWeightSpan = document.getElementById("remaining-weight-value");
  const originalRemainingWeight = parseFloat(weightInput.dataset.remainingWeight);

  function calculateAmount() {
    const sellerId = sellerSelect.value;
    const financerId = financerSelect.value;
    const weight = parseFloat(weightInput.value || 0);
    if ((billType === "seller" && (!sellerId || isNaN(weight))) ||
        (billType === "financer" && (!financerId || isNaN(weight)))) {
      return;
    }

    if (billType === "seller" && sellerSelect) {
      const item = contractItemsData.seller[sellerId];
      if (item) {
        const amount = weight * item.rate + (item.rate * item.gst / 100) * weight;
        amountInput.value = amount.toFixed(2);
      }
    } else if (billType === "financer" && financerSelect) {
      const item = contractItemsData.financer[financerId];
      if (item) {
        const amount = weight * item.rate + (item.rate * item.gst / 100) * weight;
        amountInput.value = amount.toFixed(2);
      }
    }
  }

  weightInput.addEventListener("input", function () {
    const enteredWeight = parseFloat(this.value) || 0;
    let updatedRemaining;

    if (quantityUnit === "truck" && enteredWeight > 0) {
      updatedRemaining = originalRemainingWeight - 1;
    } else {
      updatedRemaining = (originalRemainingWeight - enteredWeight).toFixed(3);
    }

    if (remainingWeightSpan) {
      remainingWeightSpan.textContent = updatedRemaining;
    }
    calculateAmount();
  });

  sellerSelect.addEventListener("change", calculateAmount);
  financerSelect?.addEventListener("change", calculateAmount);
  weightInput.addEventListener("input", calculateAmount);

  const unloadingWeightInput = document.querySelector("[name='bill[unloading_weight]']");
  const shortageDeductionInput = document.querySelector("[name='bill[shortage_deduction]']");
  const shortageRateInput = document.querySelector("[name='bill[shortage_rate]']");

  function calculateShortageDeduction() {
    const weight = parseFloat(weightInput.value || 0);
    const unloadingWeight = parseFloat(unloadingWeightInput.value || 0);
    const shortageRate = parseFloat(shortageRateInput.value || 0);
    if (isNaN(weight) || isNaN(unloadingWeight) || isNaN(shortageRate)) return;

    if (billType === "seller" && sellerSelect) {
      const sellerId = sellerSelect.value;
      const item = contractItemsData.seller[sellerId];
      if (item && unloadingWeight < weight && unloadingWeight >= 0) {
        const weightDiff = weight - unloadingWeight;
        const base = weightDiff * shortageRate;
        const gst = (shortageRate * item.gst / 100) * weightDiff;
        const deduction = base + gst;
        shortageDeductionInput.value = deduction.toFixed(2);
      } else {
        shortageDeductionInput.value = "";
      }
    }
  }

  function calculateUnloadingWeightFromDeduction() {
    const weight = parseFloat(weightInput.value || 0);
    const shortageRate = parseFloat(shortageRateInput.value || 0);
    const deduction = parseFloat(shortageDeductionInput.value || 0);
  
    if (isNaN(weight) || isNaN(deduction) || isNaN(shortageRate)) return;
  
    if (billType === "seller" && sellerSelect) {
      const sellerId = sellerSelect.value;
      const item = contractItemsData.seller[sellerId];
  
      if (item && shortageRate > 0 && item.gst != null) {
        const totalRate = shortageRate + (shortageRate * item.gst / 100);
        const weightDiff = deduction / totalRate;
        const unloadingWeight = weight - weightDiff;
  
        if (unloadingWeight >= 0) {
          unloadingWeightInput.value = unloadingWeight.toFixed(3);
        }
      }
    }
  }  

  unloadingWeightInput?.addEventListener("input", calculateShortageDeduction);
  shortageDeductionInput?.addEventListener("input", calculateUnloadingWeightFromDeduction);
  weightInput?.addEventListener("input", calculateShortageDeduction);
  sellerSelect?.addEventListener("change", calculateShortageDeduction);
  shortageRateInput?.addEventListener("change", calculateShortageDeduction);

  if (unloadingWeightInput) {
    unloadingWeightInput.addEventListener("input", function () {
      const entered = parseFloat(this.value) || 0;
      if (entered > maxWeight) {
        this.value = maxWeight.toFixed(2);
      }
      calculateShortageDeduction();
    });
  }

  const sellerBillSelect = document.getElementById("seller_bill_select");
  const billWeightInput = document.getElementById("bill_weight_input");

  if (sellerBillSelect && billWeightInput) {
    sellerBillSelect.addEventListener("change", function () {
      const selectedBillId = this.value;
      if (sellerBillWeights.hasOwnProperty(selectedBillId)) {
        const weight = parseFloat(sellerBillWeights[selectedBillId]);
        billWeightInput.value = weight.toFixed(3);
        billWeightInput.dispatchEvent(new Event("input"));
      } else {
        billWeightInput.value = "";
        billWeightInput.dispatchEvent(new Event("input"));
      }
    });

    if (!billWeightInput.value) {
      sellerBillSelect.dispatchEvent(new Event("change"));
    }
  }
});